"use client";

import * as React from "react";
import { ThemeProvider as NextThemesProvider } from "next-themes";

export function ThemeProvider({
  children,
  ...props
}: React.ComponentProps<typeof NextThemesProvider>) {
  // next-themes injects a blocking <script> for FOUC prevention. React 19 warns
  // when that tag is created during client renders. The init script lives in
  // root layout <head> instead; on the client, use a non-executable type so React
  // does not warn about a script tag inside this component tree.
  const scriptProps =
    typeof window === "undefined"
      ? undefined
      : ({ type: "application/json" } as const);

  return (
    <NextThemesProvider {...props} scriptProps={scriptProps}>
      {children}
    </NextThemesProvider>
  );
}





















































